<div class="page-container container user-management-container">
  <app-utility-toolbar></app-utility-toolbar>
  <h1 class="header col-12">User Management</h1>
  <form [formGroup]="searchForm" class="w-100">
    <div class="row">
      <mat-form-field class="col-3">
        <mat-label>User ID</mat-label>
        <input matInput [formControlName]="'id'" [placeholder]="'User ID'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>First Name</mat-label>
        <input
          matInput
          [formControlName]="'firstName'"
          [placeholder]="'First Name'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Last Name</mat-label>
        <input
          matInput
          [formControlName]="'lastName'"
          [placeholder]="'Last Name'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Username</mat-label>
        <input
          matInput
          [formControlName]="'username'"
          [placeholder]="'Username'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Unit</mat-label>
        <input matInput [formControlName]="'unit'" [placeholder]="'Unit'" />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Rep Code</mat-label>
        <input
          matInput
          [formControlName]="'repcode'"
          [placeholder]="'Rep Code'"
        />
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Role</mat-label>
        <mat-select [formControlName]="'role'">
          <mat-option value="">Any</mat-option>
          @for (role of roleData; track role.id) {
            <mat-option value="{{ role.id }}">
              {{ role.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="col-3">
        <mat-label>Save Type</mat-label>
        <mat-select [formControlName]="'saveType'">
          <mat-option value="">Any</mat-option>
          @for (saveType of allSaveTypes; track saveType.id) {
            <mat-option value="{{ saveType.id }}">
              {{ saveType.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-12 buttons mb-3">
        <button
          mat-raised-button
          class="pull-right"
          (click)="newSearch()"
          type="submit"
          color="accent"
        >
          Search
        </button>
        <button
          mat-raised-button
          class="pull-right me-2"
          (click)="clearSearch()"
        >
          Clear Search
        </button>
        @if (rights.includes('AddEditUsers')) {
          <button mat-button color="primary" (click)="openCreateUserDialog()">
            <mat-icon>add</mat-icon>Add New User
          </button>
        }
      </div>
    </div>
  </form>
  <kendo-grid
    #grid
    [kendoGridBinding]="userData['users']"
    [height]="700"
    [pageSize]="pageSize"
    [pageable]="pageableData"
    [filter]="filter"
    filterable="menu"
    (filterChange)="filterChange($event)"
    [sortable]="{ mode: 'single' }"
    [columnMenu]="{ columnChooser: false }"
    [navigable]="true"
  >
    <kendo-grid-column width="70" title="">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="edit-column">
          <button mat-icon-button (click)="editUser(dataItem)">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="id" title="User ID">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['id']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="filterValueChange($event, 'id', filterService)"
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="firstName" title="First Name">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['firstName']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="filterValueChange($event, 'firstName', filterService)"
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="lastName" title="Last Name">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['lastName']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="filterValueChange($event, 'lastName', filterService)"
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="roleSum" title="Roles">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['roleSum']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="filterValueChange($event, 'roleSum', filterService)"
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="unit" title="Unit">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['unit']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="filterValueChange($event, 'unit', filterService)"
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="saveTypeTerm" title="Save Type">
      <ng-template
        kendoGridFilterMenuTemplate
        let-filter="filter"
        let-filterService="filterService"
      >
        <kendo-multiselect
          style="width: 99%"
          [data]="filterData['saveTypeTerm']"
          textField="display"
          valueField="value"
          [valuePrimitive]="true"
          [value]="filter | filterValues"
          (valueChange)="
            filterValueChange($event, 'saveTypeTerm', filterService)
          "
          [fillMode]="'outline'"
          placeholder="Filter By..."
        ></kendo-multiselect>
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>{{ noRecordMessage }}</ng-template>
  </kendo-grid>
</div>
<ngx-loading [show]="loading"></ngx-loading>
